import { createPath, nestedPath } from '../../../constants';

export const API_ENDPOINT = 'businesses';

export const INVITATION_VERIFICATION_ENDPOINT = createPath([API_ENDPOINT, 'verify-invitation']);
export const BUSINESS_ENDPOINT = (businessId, ...args) => nestedPath(API_ENDPOINT)([businessId, ...args]);
export const BUSINESS_RESOURCE_ENDPOINT = (resource) => (businessId, ...args) =>
  BUSINESS_ENDPOINT(businessId, resource, ...args);
export const BUSINESS_USER_ENDPOINT = (businessId, userId) => (...args) =>
  BUSINESS_RESOURCE_ENDPOINT('user')(businessId, userId, ...args);
export const BUSINESS_USER_RESOURCE_ENDPOINT = (resource) => (businessId, userId, ...args) =>
  BUSINESS_USER_ENDPOINT(businessId, userId)(resource, ...args);

export const BUSINESS_TEAM_ENDPOINT = (businessId, teamId) => (...args) =>
  BUSINESS_RESOURCE_ENDPOINT('teams')(businessId, teamId, ...args);
export const BUSINESS_TEAM_RESOURCE_ENDPOINT = (resource) => (businessId, teamId, ...args) =>
  BUSINESS_TEAM_ENDPOINT(businessId, teamId)(resource, ...args);


// WEBPACK FOOTER //
// ./src/state/modules/business/endpoints.js